import React, { Fragment, useState, useEffect } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Row, Col, Button } from 'reactstrap'
import { ProgressBar } from 'primereact/progressbar'

import { getUserRating } from './redux/userActions'
import { defaultDateRange } from '../../constants/constants'
import CustomDatePicker from '../../common/CustomReactDateTimePicker/CustomReactDateTimePicker'
import CustomSelect from '../../common/CustomReactSelectComponent'
import { timeForDataPicker } from '../../utils/utcTime'
import { secondToMinutes } from '../../utils/secondToMinutes'

const DayRating = ({ getUserRating, user, userRating }) => {
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    dateRange: null,
  })

  useEffect(() => {
    const day = moment().get('date')
    const formattedDate = timeForDataPicker(new Date(moment().date(day)))
    console.log(formattedDate)
    setFilters({ ...filters, startDate: formattedDate, endDate: formattedDate })
    const ratingFilters = {
      startDate: formattedDate,
      endDate: formattedDate,
    }
    getUserRating(ratingFilters, user.userId)
  }, [])

  useEffect(() => {
    if (filters.dateRange) handleDateRangeChange()
  }, [filters.dateRange])

  const handleDateRangeChange = () => {
    let firstDate
    let secondDate
    if (filters.dateRange === 1) {
      const thisWeek = moment(new Date()).week()
      firstDate = moment().week(thisWeek).startOf('week').add(1, 'days')
      secondDate = moment().week(thisWeek).endOf('week').add(1, 'days')
    } else if (filters.dateRange === 2) {
      const lastWeek = moment(new Date()).week() - 1
      firstDate = moment().week(lastWeek).startOf('week').add(1, 'days')
      secondDate = moment().week(lastWeek).endOf('week').add(1, 'days')
    } else if (filters.dateRange === 3) {
      const thisMonth = moment(new Date()).month()
      firstDate = moment().month(thisMonth).startOf('month')
      secondDate = moment().month(thisMonth).endOf('month')
    } else if (filters.dateRange === 4) {
      const lastMonth = moment(new Date()).month() - 1
      firstDate = moment().month(lastMonth).startOf('month')
      secondDate = moment().month(lastMonth).endOf('month')
    } else if (filters.dateRange === 5) {
      const thisQuarter = moment(new Date()).quarter()
      firstDate = moment().quarter(thisQuarter).startOf('quarter')
      secondDate = moment().quarter(thisQuarter).endOf('quarter')
    } else if (filters.dateRange === 6) {
      const lastQuarter = moment(new Date()).quarter() - 1
      firstDate = moment().quarter(lastQuarter).startOf('quarter')
      secondDate = moment().quarter(lastQuarter).endOf('quarter')
    } else if (filters.dateRange === 7) {
      const thisYear = moment(new Date()).year()
      firstDate = moment().year(thisYear).startOf('year')
      secondDate = moment().year(thisYear).endOf('year')
    } else if (filters.dateRange === 8) {
      const lastYear = moment(new Date()).year() - 1
      firstDate = moment().year(lastYear).startOf('year')
      secondDate = moment().year(lastYear).endOf('year')
    } else {
      firstDate = ''
      secondDate = ''
    }
    setFilters({
      ...filters,
      startDate: firstDate ? timeForDataPicker(new Date(firstDate)) : '',
      endDate: secondDate ? timeForDataPicker(new Date(secondDate)) : '',
    })
  }

  const onChangeFilters = (e) => {
    const { name, value } = e.target
    setFilters({ ...filters, [name]: value })
  }

  const onChangeSelect = (value) => {
    setFilters({ ...filters, dateRange: value ? value.value : null })
  }

  const onSearchClick = () => {
    getUserRating(filters, user.userId)
  }

  const displayValueInProgress = (actual, expectation) => {
    if (!actual || !expectation) return 0
    return (actual / (expectation / 100)).toFixed(2)
  }

  return (
    <Fragment>
      <Row className='d-flex align-items-end'>
        <Col md='3'>
          <CustomDatePicker
            label='Start Date'
            name='startDate'
            placeholder='mm/dd/yyyy'
            disabled={false}
            onChange={onChangeFilters}
            value={filters.startDate}
            baseZIndex={1500}
          />
        </Col>
        <Col md='3'>
          <CustomDatePicker
            label='End Date'
            name='endDate'
            placeholder='mm/dd/yyyy'
            disabled={false}
            onChange={onChangeFilters}
            value={filters.endDate}
            baseZIndex={1500}
          />
        </Col>
        <Col md='3'>
          <CustomSelect
            options={defaultDateRange}
            name='dateRange'
            defaultValue={filters.dateRange}
            onChange={onChangeSelect}
            isClearable={true}
            isMulti={false}
            label='Date Range'
          />
        </Col>
        <Col md='3'>
          <Button onClick={onSearchClick} className='gold-color-button' size='sm'>
            Search
          </Button>
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col>
          Productivity report includes your daily completed activities compared in relation with your expected
          activities. Building a history of your productivity will help better organize and manage your time and
          evaluate your overall performance.
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>

      <Row className='d-flex align-items-center mb-3'>
        <Col md='4'>Phone Calls</Col>
        <Col md='1'>
          <span className=''>{(userRating.calculatedActual && userRating.calculatedActual.phoneCallsCount) || 0}</span>
        </Col>
        <Col md='6'>
          <ProgressBar
            value={
              userRating.calculatedActual &&
              userRating.calculatedExpectation &&
              displayValueInProgress(
                userRating.calculatedActual.phoneCallsCount,
                userRating.calculatedExpectation.phoneCalls
              )
            }
            style={{ color: '#ceac02' }}
          />
        </Col>
        <Col md='1'>
          <span className=''>
            {(userRating.calculatedExpectation && userRating.calculatedExpectation.phoneCalls) || 0}
          </span>
        </Col>
      </Row>

      <Row className='d-flex align-items-center mb-3'>
        <Col md='4'>Meetings</Col>
        <Col md='1'>
          <span className=''>{(userRating.calculatedActual && userRating.calculatedActual.meetingsCount) || 0}</span>
        </Col>
        <Col md='6'>
          <ProgressBar
            value={
              userRating.calculatedActual &&
              userRating.calculatedExpectation &&
              displayValueInProgress(
                userRating.calculatedActual.meetingsCount,
                userRating.calculatedExpectation.meetings
              )
            }
            style={{ color: '#ceac02' }}
          />
        </Col>
        <Col md='1'>
          <span className=''>
            {(userRating.calculatedExpectation && userRating.calculatedExpectation.meetings) || 0}
          </span>
        </Col>
      </Row>

      <Row className='d-flex align-items-center mb-3'>
        <Col md='4'>Call Time</Col>
        <Col md='1'>
          <span className=''>
            {userRating.calculatedActual ? secondToMinutes(userRating.calculatedActual.callTimeSum, 'seconds') : 0}
          </span>
        </Col>
        <Col md='6'>
          <ProgressBar
            value={
              userRating.calculatedActual &&
              userRating.calculatedExpectation &&
              displayValueInProgress(
                userRating.calculatedActual.callTimeSum / 60,
                userRating.calculatedExpectation.callTime
              )
            }
            style={{ color: '#ceac02' }}
          />
        </Col>
        <Col md='1'>
          <span className=''>
            {userRating.calculatedExpectation
              ? secondToMinutes(userRating.calculatedExpectation.callTime, 'minutes')
              : 0}
          </span>
        </Col>
      </Row>

      <Row className='d-flex align-items-center mb-3'>
        <Col md='4'>Lead To Prospect Conversions</Col>
        <Col md='1'>
          <span className=''>
            {(userRating.calculatedActual && userRating.calculatedActual.leadToProspectConversionCount) || 0}
          </span>
        </Col>
        <Col md='6'>
          <ProgressBar
            value={
              userRating.calculatedActual &&
              userRating.calculatedExpectation &&
              displayValueInProgress(
                userRating.calculatedActual.leadToProspectConversionCount,
                userRating.calculatedExpectation.leadToProspectConversion
              )
            }
            style={{ color: '#ceac02' }}
          />
        </Col>
        <Col md='1'>
          <span className=''>
            {(userRating.calculatedExpectation && userRating.calculatedExpectation.leadToProspectConversion) || 0}
          </span>
        </Col>
      </Row>

      <Row className='d-flex align-items-center mb-3'>
        <Col md='4'>Prospect To Account Conversions</Col>
        <Col md='1'>
          <span className=''>
            {(userRating.calculatedActual && userRating.calculatedActual.prospectToAccountConversionCount) || 0}
          </span>
        </Col>
        <Col md='6'>
          <ProgressBar
            value={
              userRating.calculatedActual &&
              userRating.calculatedExpectation &&
              displayValueInProgress(
                userRating.calculatedActual.prospectToAccountConversionCount,
                userRating.calculatedExpectation.prospectToAccountConversion
              )
            }
            style={{ color: '#ceac02' }}
          />
        </Col>
        <Col md='1'>
          <span className=''>
            {(userRating.calculatedExpectation && userRating.calculatedExpectation.prospectToAccountConversion) || 0}
          </span>
        </Col>
      </Row>
    </Fragment>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  userRating: state.users.userRating,
})

export default connect(mapStateToProps, { getUserRating })(DayRating)
